/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
const interactions = ['none', 'hover', 'click'];
export const isPersonCardInteraction = (value) => typeof value === 'string' && interactions.includes(value);
export const personCardConverter = (value, defaultValue = 'none') => {
    if (isPersonCardInteraction(value)) {
        return value;
    }
    return defaultValue;
};
